function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-62"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 391.92,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.14,
    y: 389.21,
    width: 42.53,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 395.43,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.67,
    y: 399.53,
    width: 15.23,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.47,
    y: 399.53,
    width: 34.29,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 392.33,
    width: 23.83,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.92a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,43.92,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.92,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.5,
    y: 88.22,
    width: 107.87,
    height: 108.16,
    transform: "translate(722.87 284.59) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.64,
    y: 88.22,
    width: 1.86,
    height: 108.16,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.02,
    y: 95.05,
    width: 88.82,
    height: 94.5,
    transform: "translate(722.87 284.59) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,169h28.13c6.1,0,10.18-4.94,9.11-11l-5.47-31.33a13.7,13.7,0,0,0-13-11H342.71c-6.1,0-10.18,4.94-9.11,11L339.07,158A13.69,13.69,0,0,0,352,169Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.97,
    y: 229.22,
    width: 24,
    height: 148.05,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.42,
    y: 377.28,
    width: 126.86,
    height: 5.11,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 229.22,
    width: 107.42,
    height: 148.05,
    transform: "translate(317.35 606.5) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.28,
    y: 306.32,
    width: 98.78,
    height: 26.44,
    transform: "translate(317.35 639.07) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.28,
    y: 340.92,
    width: 98.78,
    height: 26.44,
    transform: "translate(317.35 708.27) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.8,
    y: 304.69,
    width: 77.76,
    height: 3.63,
    rx: 1.18,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.8,
    y: 339.3,
    width: 77.76,
    height: 3.63,
    rx: 1.18,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.28,
    y: 237.39,
    width: 98.78,
    height: 26.44,
    transform: "translate(317.35 501.21) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.28,
    y: 271.71,
    width: 98.78,
    height: 26.44,
    transform: "translate(317.35 569.87) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.8,
    y: 235.77,
    width: 77.76,
    height: 3.63,
    rx: 1.18,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.8,
    y: 270.09,
    width: 77.76,
    height: 3.63,
    rx: 1.18,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.79,
    y: 80.06,
    width: 134.71,
    height: 118.26,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.94,75.46H65.07a1.33,1.33,0,0,0-1.33,1.34h0a1.33,1.33,0,0,0,1.33,1.33H222.94a1.34,1.34,0,0,0,1.34-1.33h0A1.34,1.34,0,0,0,222.94,75.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.46,
    y: 80.06,
    width: 137.76,
    height: 118.26,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.5 198.32 73.79 198.32 73.79 202.11 212.44 202.11 208.5 198.32",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.74 198.32 85.99 198.32 89.92 202.11 227.68 202.11 223.74 198.32",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.21,
    y: 78.31,
    width: 102.26,
    height: 121.75,
    transform: "translate(284.53 -6.15) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.11 190.32 159.07 88.06 181.25 88.06 134.28 190.32 112.11 190.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.04 190.32 186.01 88.06 194.65 88.06 147.69 190.32 139.04 190.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.58,
    y: 138.68,
    width: 102.26,
    height: 1.02,
    transform: "translate(344.9 -66.52) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.79,
    y: 73.07,
    width: 13.77,
    height: 97.59,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.2,
    y: 73.07,
    width: 10.73,
    height: 97.59,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.56,
    y: 73.07,
    width: 13.77,
    height: 97.59,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.97,
    y: 73.07,
    width: 10.73,
    height: 97.59,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.33,
    y: 73.07,
    width: 13.77,
    height: 97.59,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.16,
    y: 73.07,
    width: 7.94,
    height: 97.59,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 73.07,
    width: 6.18,
    height: 97.59,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.09,
    y: 73.07,
    width: 7.94,
    height: 97.59,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.94,
    y: 73.07,
    width: 6.18,
    height: 97.59,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.03,
    y: 73.07,
    width: 7.94,
    height: 97.59,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M356.85,269.21a7.34,7.34,0,1,0,7.92-6.72A7.35,7.35,0,0,0,356.85,269.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.17,
    cy: 273.66,
    r: 7.35,
    transform: "translate(-35.81 57.64) rotate(-8.37)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.72,274.55a7.34,7.34,0,1,0,7.92-6.72A7.33,7.33,0,0,0,381.72,274.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.2,273.06a7.34,7.34,0,1,0,7.92-6.72A7.35,7.35,0,0,0,343.2,273.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.63,
    cy: 273.66,
    r: 7.35,
    transform: "translate(-35.56 61.05) rotate(-8.37)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.66,
    cy: 269.27,
    r: 7.35,
    transform: "matrix(0.76, -0.65, 0.65, 0.76, -93.31, 284.23)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.92,271.39a7.34,7.34,0,1,0,7.92-6.72A7.35,7.35,0,0,0,322.92,271.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.53,273.37s1.26,30.07,49.58,30.07,49.58-30.07,49.58-30.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.07,
    y: 303.44,
    width: 9.19,
    height: 78.95,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.3,
    y: 303.44,
    width: 5.41,
    height: 78.95,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.97,
    y: 303.44,
    width: 9.19,
    height: 78.95,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.47,
    y: 303.44,
    width: 5.41,
    height: 78.95,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.93,
    y: 303.44,
    width: 130.46,
    height: 9.57,
    transform: "translate(760.32 616.46) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.87,
    y: 303.44,
    width: 9.19,
    height: 78.95,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.37,
    y: 303.44,
    width: 5.41,
    height: 78.95,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.23,
    y: 303.44,
    width: 46.77,
    height: 9.57,
    transform: "translate(575.23 616.46) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.96,
    y: 303.44,
    width: 9.19,
    height: 78.95,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.2,
    y: 303.44,
    width: 5.41,
    height: 78.95,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-62"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-62",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trash--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.48,406.31a8.44,8.44,0,0,1-7.05,8.33,220.3,220.3,0,0,1-73.3,0,8.43,8.43,0,0,1-7-8.33v-81h87.39Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08,326.77v11.37c5.26,1.95,22.53,3.38,43.7,3.38s38.47-1.43,43.7-3.38V326.77Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.12,335.44c0,2.57-19.84,4.65-45.34,4.65s-45.34-2.08-45.34-4.65l-.83-10.1H358Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.78,
    cy: 325.34,
    rx: 46.17,
    ry: 4.64,
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.78,
    cy: 325.34,
    rx: 46.17,
    ry: 4.64,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.8,400.61h0a3.4,3.4,0,0,1-3.39-3.39V350.78a3.4,3.4,0,0,1,3.39-3.39h0a3.41,3.41,0,0,1,3.39,3.39v46.44A3.41,3.41,0,0,1,279.8,400.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.77,400.61h0a3.4,3.4,0,0,1-3.39-3.39V350.78a3.4,3.4,0,0,1,3.39-3.39h0a3.41,3.41,0,0,1,3.39,3.39v46.44A3.41,3.41,0,0,1,343.77,400.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.44,400.61h0a3.41,3.41,0,0,1-3.39-3.39V350.78a3.41,3.41,0,0,1,3.39-3.39h0a3.4,3.4,0,0,1,3.39,3.39v46.44A3.4,3.4,0,0,1,322.44,400.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.12,400.61h0a3.41,3.41,0,0,1-3.39-3.39V350.78a3.41,3.41,0,0,1,3.39-3.39h0a3.4,3.4,0,0,1,3.39,3.39v46.44A3.4,3.4,0,0,1,301.12,400.61Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.88,139.16a4.64,4.64,0,1,1-4.64-4.64A4.64,4.64,0,0,1,192.88,139.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.51,139.83a.24.24,0,0,1-.22-.13,4.88,4.88,0,0,1,8.58-4.67.26.26,0,0,1-.1.34.25.25,0,0,1-.34-.1,4.38,4.38,0,0,0-7.7,4.19.25.25,0,0,1-.1.34A.27.27,0,0,1,184.51,139.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,160.36a4.89,4.89,0,0,1-3.91-7.8,4.88,4.88,0,0,1,3.21-1.91.24.24,0,0,1,.28.21.25.25,0,0,1-.21.28,4.38,4.38,0,0,0,1.27,8.67.25.25,0,0,1,.08.5A5.81,5.81,0,0,1,180,160.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.21,167.92a4.83,4.83,0,0,1-2.64-.79.26.26,0,0,1-.08-.35.26.26,0,0,1,.35-.07,4.38,4.38,0,0,0,4.77-7.35.26.26,0,0,1-.08-.35.26.26,0,0,1,.35-.07,4.89,4.89,0,0,1,1.44,6.75,4.82,4.82,0,0,1-3.08,2.12A5.15,5.15,0,0,1,205.21,167.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.64,
    cy: 147.07,
    r: 6.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.64,
    cy: 155.9,
    r: 8.7,
    transform: "translate(-55.86 176.93) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.56,
    cy: 166.96,
    r: 9.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.19,
    cy: 167.63,
    r: 9.62,
    transform: "translate(-12.03 320.05) rotate(-76.72)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.09,187.46c0,.78,0,1.77.07,2.67s.07,1.86.13,2.79c.13,1.86.26,3.74.46,5.61q.54,5.63,1.51,11.21c.17.92.32,1.86.51,2.78l.44,2.27c.11.36,0,.29-.14.28s0,.18.59.18A12.58,12.58,0,0,0,236,214c.8-.36,1.62-.75,2.44-1.17s1.65-.9,2.4-1.32l2.92,3.37a28.1,28.1,0,0,1-2.22,2.27,25.67,25.67,0,0,1-2.44,2.05,22.09,22.09,0,0,1-2.83,1.81,13.55,13.55,0,0,1-3.58,1.34,9.12,9.12,0,0,1-2.35.2,7.64,7.64,0,0,1-2.78-.7,7.34,7.34,0,0,1-2.43-1.84,8.81,8.81,0,0,1-1.4-2.25,12.65,12.65,0,0,1-.66-1.93l-.39-1.46c-.28-1-.51-1.95-.75-2.93a111.47,111.47,0,0,1-2.16-11.92c-.25-2-.45-4-.57-6.05-.06-1-.11-2-.14-3.06s0-2,0-3.19Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.24,176.68c8.53,6.53,8.19,18.84,8.19,18.84l-15.26,3.65s-4.68-12.38-2.78-16.91C215.37,177.54,218.44,173,223.24,176.68Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.24,176.68c8.53,6.53,8.19,18.84,8.19,18.84l-15.26,3.65s-4.68-12.38-2.78-16.91C215.37,177.54,218.44,173,223.24,176.68Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.27,212.66l2.52-4.24,6.32,6.76s-4.53,2.9-9.23.83Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.9 206.39 254.01 211.17 249.11 215.18 242.79 208.42 245.9 206.39",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.49 408.86 184.21 409.7 189.63 389.27 180.9 388.43 175.49 408.86",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.79 391.69 138.62 395.79 147.93 377.33 140.1 373.23 130.79 391.69",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.71,392.2l-7-7.11a.69.69,0,0,0-.92-.08l-6.43,4.73a1.43,1.43,0,0,0-.12,2.12c2.48,2.44,3.8,3.49,6.88,6.62,1.9,1.92,5.8,6.45,8.42,9.11s5.38.21,4.53-1.13c-3.82-6-4.46-9.77-4.7-12.82A2.31,2.31,0,0,0,140.71,392.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.57,407.05H175a.87.87,0,0,0-.83.64L171.91,416a1.31,1.31,0,0,0,1.29,1.67c3.71,0,5.47,0,10.1,0h14.17c3.85,0,4.66-3.89,3.06-4.25-7.14-1.58-11.26-3.76-13.46-5.84A2.21,2.21,0,0,0,185.57,407.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.62 389.28 186.83 399.81 177.88 399.81 180.89 388.44 189.62 389.28",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.09 373.23 147.93 377.34 143.13 386.85 135.29 382.74 140.09 373.23",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,175.42s3.86,1.69-9.08,52.89l-35.94-3.11c1.87-14.57,2.66-23.59-1.73-54.22a107.55,107.55,0,0,1,15.44-.69,115.37,115.37,0,0,1,16.32,1.41A152.47,152.47,0,0,1,220.66,175.42Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,175.42s3.86,1.69-9.08,52.89l-35.94-3.11c1.87-14.57,2.66-23.59-1.73-54.22a107.55,107.55,0,0,1,15.44-.69,115.37,115.37,0,0,1,16.32,1.41A152.47,152.47,0,0,1,220.66,175.42Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.35,170s-2,0-4.45,0c-1.45,2.23,4.67,8.74,12.45,15.14,1.88-5.83,4.84-5.81,4.84-5.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.66,171.57s.91.13,3.09.63c1.44,2.23,2.25,7.81-2,12.67-1.67-6-4.55-5.46-4.55-5.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.55,152.05c.58,5.34.77,15-3.2,18.24,0,0,4.24,4.34,12.84,9.12,6.24-4.32,3.48-7.71,3.48-7.71-5.74-1.9-5.21-6.23-3.84-10.23Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.34,155.9l5.49,5.57a16.7,16.7,0,0,0-.76,2.85c-2.2-.51-5.4-2.81-5.44-5.17A9.25,9.25,0,0,1,196.34,155.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.17,134.63c3.68,3.26,4.76,11.2,1.26,16.59A73,73,0,0,1,213.17,134.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.43,140.84c-.64,8.79-1.09,12.5,2.71,17.57,5.72,7.63,16.66,6.48,19.91-1.94,2.93-7.59,3.48-20.69-4.59-25.31A12,12,0,0,0,191.43,140.84Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.26,147.92c6.5-.25,10.1-8.75,8.47-12.34,7.37,3.84,18.53,6.86,17.29,1.92-1.67-6.67-9.74-11.56-19.67-8C190.6,132,185.68,137.5,190.26,147.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.28,147.91a6.5,6.5,0,0,0,2.58,4.19c1.84,1.31,3.52-.15,3.65-2.28.12-1.93-.69-4.93-2.85-5.39A2.89,2.89,0,0,0,188.28,147.91Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.58,228.31s8.13,53.05,3.6,87.13c-3.43,25.75-25.56,81.31-25.56,81.31l-14.37-.39s14.84-53.85,17.91-75c5.25-36.22-7.9-95.29-7.9-95.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.56,239.18l-7.67,12.09a370.91,370.91,0,0,1,4.39,43.3C205.06,275.27,200,249.39,197.56,239.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.86 397.55 173.8 397.06 174.9 391.25 193.56 391.36 191.86 397.55",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.72,227.74s-6,58.74-19.71,90.7c-11.09,25.8-37.53,67.07-37.53,67.07l-10.56-6.18s17-45.89,25.39-63.09c20.47-42.17,1.43-76,14.33-91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.63 386.41 134.16 379.02 136.35 373.26 150.7 381.36 147.63 386.41",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.28,223.05l-1.9,3.08c-.14.23.13.52.55.55l37.69,3.26c.32,0,.61-.11.64-.31l.61-3.19c0-.22-.23-.43-.58-.46l-36.4-3.15A.68.68,0,0,0,175.28,223.05Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.82,227.54l-1-.08c-.19,0-.33-.13-.31-.25l.82-4.14c0-.13.21-.21.4-.19l1,.08c.2,0,.34.13.31.25l-.81,4.14C180.19,227.47,180,227.56,179.82,227.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.85,230.05l-1-.08c-.2,0-.34-.13-.31-.25l.82-4.14c0-.12.2-.21.39-.19l1,.08c.19,0,.33.13.31.25l-.82,4.14C209.22,230,209,230.07,208.85,230.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.33,228.8l-1-.09c-.19,0-.33-.13-.31-.25l.82-4.14c0-.12.2-.21.4-.19l1,.09c.19,0,.33.13.31.25l-.82,4.14C194.71,228.73,194.53,228.81,194.33,228.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.2,145.21c-.1.71.2,1.34.66,1.4s.92-.46,1-1.17-.21-1.34-.67-1.4S205.29,144.5,205.2,145.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.22,146.29c-.09.71.21,1.34.67,1.4s.92-.46,1-1.17-.2-1.34-.66-1.4S213.32,145.58,213.22,146.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,145.13l1.78-.26S214.74,146.08,214,145.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.07,147.07a19.38,19.38,0,0,0,1.92,4.87,3.08,3.08,0,0,1-2.59.14Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.24,154.2a5.83,5.83,0,0,1-3.3-2.73.18.18,0,0,1,.08-.23.18.18,0,0,1,.24.08,5.7,5.7,0,0,0,4.31,2.84.17.17,0,0,1,0,.34A6.1,6.1,0,0,1,205.24,154.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.55,141.1a.39.39,0,0,1-.15-.11.34.34,0,0,1,0-.49,4.06,4.06,0,0,1,3.66-.92.34.34,0,0,1,.23.43.35.35,0,0,1-.43.24,3.4,3.4,0,0,0-3,.78A.38.38,0,0,1,201.55,141.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.59,143.23a.42.42,0,0,1-.14-.09,3.44,3.44,0,0,0-2.87-1.2.33.33,0,0,1-.4-.29.35.35,0,0,1,.29-.4,4.11,4.11,0,0,1,3.49,1.42.35.35,0,0,1-.37.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.5,218.68a16.13,16.13,0,1,1,30.72,9.86L249,248l-30.72-9.87Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.5,218.68a16.13,16.13,0,1,1,30.72,9.86L249,248l-30.72-9.87Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.19,208.94l-5.62,17.5a2,2,0,0,0,1.3,2.53l28.4,9.12,6.24-19.42a16.13,16.13,0,0,1,20.28-10.42l-30.31-9.74a16.15,16.15,0,0,0-20.29,10.43Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.43,222.21l7.83-24.37a.64.64,0,0,0-.51-.82l-8-1.18-1,3.16,5.83,1.87-6.6,20.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.27,220.87a3,3,0,1,0,3.78-1.94A3,3,0,0,0,205.27,220.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.75,241l39.4,12.65a1.14,1.14,0,0,0,1.44-.74h0a1.13,1.13,0,0,0-.74-1.44l-41.58-13.35h0A2.29,2.29,0,0,0,219.75,241Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.75,241l16.1,5.17a1.15,1.15,0,0,0,1.45-.74h0a1.15,1.15,0,0,0-.74-1.44l-18.29-5.87h0A2.29,2.29,0,0,0,219.75,241Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.14,185.1l-.55.61-.62.71c-.42.48-.84,1-1.24,1.49-.82,1-1.6,2.07-2.33,3.15A53.61,53.61,0,0,0,166.34,205c-.4,1.24-.77,2.48-1.06,3.75-.1.37-.11.52-.16.69a4.2,4.2,0,0,0,0,.44,2.3,2.3,0,0,0,0,.47c0,.18.34.6,1.16,1a12.71,12.71,0,0,0,3.09.94,42.34,42.34,0,0,0,7.78.51c2.72,0,5.48-.24,8.24-.53s5.56-.65,8.27-1.06l1.09,4.33a91.59,91.59,0,0,1-17.15,3.81,43,43,0,0,1-9.25.2,19,19,0,0,1-5.14-1.22,11.51,11.51,0,0,1-2.76-1.58,9,9,0,0,1-2.4-2.87,10.2,10.2,0,0,1-.77-6.73c.24-1.53.59-3,1-4.54A52,52,0,0,1,161.4,194a59.39,59.39,0,0,1,4.51-8c.86-1.27,1.78-2.5,2.74-3.71.49-.6,1-1.19,1.5-1.78l.81-.87c.29-.31.52-.56.92-.94Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.48,212.13l7-3.71.31,7.52s-5,2.07-7.86-.21Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.25 207.85 203.2 214.78 198.8 215.94 198.49 208.42 204.25 207.85",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.91,171c-4.41.78-10.58,13.42-10.58,13.42l11.11,10s8.83-9.64,8.36-15.38C182.4,174.19,179.52,170,173.91,171Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.91,171c-4.41.78-10.58,13.42-10.58,13.42l11.11,10s8.83-9.64,8.36-15.38C182.4,174.19,179.52,170,173.91,171Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.15,396.06a1.34,1.34,0,0,1-.35,0c-1.11-.06-2.29-1.76-2.9-2.76a.17.17,0,0,1,0-.19.16.16,0,0,1,.18-.07c.36.07,3.47.77,3.86,1.82a.7.7,0,0,1-.12.68A1.32,1.32,0,0,1,144.15,396.06Zm-2.73-2.54c.89,1.37,1.77,2.19,2.4,2.23a.83.83,0,0,0,.72-.39.32.32,0,0,0,.07-.34C144.37,394.38,142.5,393.78,141.42,393.52Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.83,393.3a6.32,6.32,0,0,1-2.83.12.18.18,0,0,1-.12-.13.18.18,0,0,1,0-.17c.08-.07,1.9-1.85,3.17-1.76a1,1,0,0,1,.8.42.72.72,0,0,1,.08.88A2,2,0,0,1,143.83,393.3Zm-2.41-.16c1,.14,2.87-.11,3.26-.68.06-.09.11-.23-.07-.46a.67.67,0,0,0-.54-.29C143.2,391.65,141.94,392.67,141.42,393.14Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.3,408.39a13.91,13.91,0,0,1-2.87-.37.17.17,0,0,1,0-.32c.43-.21,4.26-2,5.22-1.32a.58.58,0,0,1,.25.54,1.28,1.28,0,0,1-.52,1A3.49,3.49,0,0,1,189.3,408.39Zm-2.27-.6c1.13.21,3.23.49,4.1-.16a1,1,0,0,0,.38-.73.22.22,0,0,0-.1-.23C190.87,406.3,188.61,407.09,187,407.79Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.46,408a.21.21,0,0,1-.11,0,.2.2,0,0,1-.06-.18c0-.16.91-3.93,3-3.69.52.07.66.32.69.53.13,1-2.28,2.89-3.43,3.37Zm2.62-3.57c-1.32,0-2.09,2.2-2.35,3.08,1.25-.66,3-2.23,2.89-2.84,0-.05,0-.19-.39-.23Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,144.05l1.77-.26S206.72,145,206,144.05Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--E-mails--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.53,227.71l-38.72,8a2.58,2.58,0,0,1-3-2L224,225.31l-.65-3.1,1.14-3.54a12.72,12.72,0,0,1,.57-1.49,1.07,1.07,0,0,1,.1-.22,15.43,15.43,0,0,1,2.55-4l2-.42,33.2-6.89a2.58,2.58,0,0,1,3,2l3.53,17A2.58,2.58,0,0,1,267.53,227.71Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.61,206.75l-18.68,19-4-1.62-15.56-6.31-2.19-.89a15.43,15.43,0,0,1,2.55-4l2-.42,33.2-6.89A2.59,2.59,0,0,1,265.61,206.75Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.61,206.75l-22.68,17.41-1.48,1.14-14.25-7.07-2.12-1a1.07,1.07,0,0,1,.1-.22,15.43,15.43,0,0,1,2.55-4l2-.42,33.2-6.89A2.59,2.59,0,0,1,265.61,206.75Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.61,206.75l-22.68,17.41-1.48,1.14-14.25-7.07-2.12-1a1.07,1.07,0,0,1,.1-.22,15.43,15.43,0,0,1,2.55-4l2-.42,33.2-6.89A2.59,2.59,0,0,1,265.61,206.75Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.8,262.78,303,275.5a2.58,2.58,0,0,1-3.63.13l-28.94-26.95a2.57,2.57,0,0,1-.13-3.63l11.84-12.72a2.56,2.56,0,0,1,3.64-.13l28.93,26.95a2.57,2.57,0,0,1,.65,2.8A2.36,2.36,0,0,1,314.8,262.78Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.32,262,289,257.71l-6.11-26a2.6,2.6,0,0,1,2.85.45l28.93,26.95A2.57,2.57,0,0,1,315.32,262Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.32,262l-25.63-7.64-6.8-22.56a2.6,2.6,0,0,1,2.85.45l28.93,26.95A2.57,2.57,0,0,1,315.32,262Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.32,262l-25.63-7.64-6.8-22.56a2.6,2.6,0,0,1,2.85.45l28.93,26.95A2.57,2.57,0,0,1,315.32,262Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.09,283.73l13,15.18a2.81,2.81,0,0,1-.43,4.06l-28.24,22a2.23,2.23,0,0,1-2.94-.58l-10.17-11.6a3.08,3.08,0,0,1-.47-.74,2.15,2.15,0,0,1,.23-2.32l25-26.11a2.69,2.69,0,0,1,3.14-.6A3,3,0,0,1,325.09,283.73Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.21,283.05,318,310.67l-22.12,1.41a2.15,2.15,0,0,1,.23-2.32l25-26.11A2.69,2.69,0,0,1,324.21,283.05Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.21,283.05,313.8,312.36l-17.94-.28a2.15,2.15,0,0,1,.23-2.32l25-26.11A2.69,2.69,0,0,1,324.21,283.05Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.21,283.05,313.8,312.36l-17.94-.28a2.15,2.15,0,0,1,.23-2.32l25-26.11A2.69,2.69,0,0,1,324.21,283.05Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.65146ddfa2ce0fe30f835a84ea434a20.svg";
export { ForwardRef as ReactComponent };